import React from 'react';

const Comp1 = (props) => {
    return (
        <div class="sec">
            <h1 class="head head_1">1</h1>
            <div class="sec_1"></div>
        </div>
    );
}

export default Comp1;

